import { render, staticRenderFns } from "./FotosMaquinas.vue?vue&type=template&id=2e22824b&scoped=true&"
import script from "./FotosMaquinas.vue?vue&type=script&lang=js&"
export * from "./FotosMaquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22824b",
  null
  
)

export default component.exports